// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__1lp22","hasImage":"styles_hasImage__QguqV","initials":"styles_initials__rwmsz"};